import React from 'react';
import Head from 'next/head';
import Link from '../components/link';
import { baseUrl } from '../lib/url';

const title = 'Om oss | Alla Presenter';
const description =
  'Alla Presenter är en sajt där du hittar utvalda presenttips som går att köpa via nätet till riktigt bra pris för alla tillfällen';
const ldjson = `{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "${title}",
  "description": "${description}",
  "url": "${baseUrl('/om-oss/')}"
}`;

const AboutUs = () => (
  <div className="container mx-auto">
    <Head>
      <title>{title}</title>
      <link rel="canonical" href={baseUrl('/om-oss/')} />
      <meta name="description" content={description} />
      <meta property="og:locale" content="sv_SE" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={baseUrl('/om-oss/')} />
      <meta property="og:site_name" content="Alla Presenter" />
      <meta property="og:image" content={baseUrl('/images/logo.png')} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={baseUrl('/images/logo.png')} />
      <meta name="twitter:card" content="summary" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: ldjson }} />
    </Head>
    <div className="flex flex-wrap content-center my-20">
      <div className="w-11/12 lg:w-2/4 m-auto">
        <h1 className="text-2xl">Om oss</h1>
        <p className="py-2">
          Alla Presenter är en sajt där du hittar utvalda presenttips som går att köpa via nätet
          till riktigt bra pris för alla tillfällen. Vi vet hur svårt det är att hitta presenter,
          just därför har vi skapat{' '}
          <Link to={baseUrl('/')} target="_self">
            allapresenter.com
          </Link>
          . Vi har presenter för olika{' '}
          <Link to={baseUrl('/tillfallen/')} target="_self">
            tillfällen
          </Link>
          , t ex{' '}
          <Link to={baseUrl('/presenter/presenter-till-alla-hjartans-dag/')} target="_self">
            alla hjärtans dag presenter
          </Link>
          .
        </p>
        <p className="py-2">
          Vi har även presenter för olika{' '}
          <Link to={baseUrl('/mottagare/')} target="_self">
            mottagare
          </Link>
          , t ex till{' '}
          <Link to={baseUrl('/presenter/presenter-till-henne/')} target="_self">
            henne
          </Link>{' '}
          eller{' '}
          <Link to={baseUrl('/presenter/presenter-till-honom/')} target="_self">
            honom
          </Link>
          . Vi har presenter för alla tillfällen, det finns nästan alltid en anledning till att
          fira!
        </p>
        <p className="py-2">
          Bra att veta är att{' '}
          <Link to={baseUrl('/')} target="_self">
            allapresenter.com
          </Link>{' '}
          inte säljer några faktiska produkter, utan det vi gör är att länka till återförsäljare av
          de produkter vi hittar på nätet. Blir de något fel eller du vill skicka tillbaka en
          produkt så är de återförsäljaren du ska kontakta och inte oss.
        </p>
        <p className="py-2">
          Vi jobbar ständigt på att förbättra vår sida genom b.la. att utöka sortimentet och våra
          kategorier.
        </p>
      </div>
    </div>
  </div>
);

export default AboutUs;
